function isFullscreen(): boolean {
    return document.fullscreenElement !== null;
}

function open(element?: HTMLElement): void {
    if (!document.fullscreenElement) {
        void (element ?? document.documentElement).requestFullscreen();
    }
}

function close(): void {
    if (document.fullscreenElement) {
        void document.exitFullscreen();
    }
}

function toggle(element?: HTMLElement): boolean {
    //
    if (document.fullscreenElement) {
        void document.exitFullscreen();
    }
    //
    else {
        void (element ?? document.documentElement).requestFullscreen();
    }

    //
    return isFullscreen();
}

// ----------------------------------------------------------------------------

export { isFullscreen, open, close, toggle };
